export const DESTINATION_TYPE_ENUM = {
  PreDepartureLocation: 1,
  DepartureLocation: 2,
  PostDepartureLocation: 3,
  ArrivalLocation: 4,
};
